import { Controller } from "stimulus"
import { EditorState } from "@codemirror/state";
import { EditorView, keymap, lineNumbers, highlightActiveLine } from "@codemirror/view";
import { syntaxHighlighting, defaultHighlightStyle, indentOnInput } from "@codemirror/language";
import { defaultKeymap } from "@codemirror/commands";
import { html } from "@codemirror/lang-html";

const fontSize14px = EditorView.theme({
  // main editable text
  ".cm-content": { fontSize: "14px" },
  // line-number gutter
  ".cm-gutter":  { fontSize: "14px" }
});

export default class extends Controller {
  static targets = ["editor"];
  static values = { readonly: Boolean };

  connect() {
    const textarea = this.editorTarget;
    const is_readonly = textarea.hasAttribute("readonly");

    this.editor = new EditorView({
      defaultKeymap,
      state: EditorState.create({
        doc: textarea.value,
        scrollbarStyle: "simple",
        extensions: [
          EditorView.editable.of(!is_readonly),
          fontSize14px,
          highlightActiveLine(),
          lineNumbers(),
          indentOnInput(),
          syntaxHighlighting(defaultHighlightStyle), 
          html(),
          keymap.of(defaultKeymap),
          EditorView.updateListener.of((view) => {
            if (view.docChanged) { 
              this.sync() 
            }
          }),
        ],
      }),
      parent: textarea.parentNode, 
    });

    textarea.style.display = "none";
  }

  disconnect() {
    this.editor.destroy();
  }

  sync() {
    const value = this.editor.state.doc.toString();
    this.editorTarget.value = value;
    this.editorTarget.innerHTML = value;
  }
}


